<template>
  <router-view/>
</template>

<script>
export default {
  name: "container"
}
</script>